<template>
  <b-card
    :title="$t('label_reports_genderGap_genderEqualityIndex_title')"
    :style="{ minHeight: height }"
  >
    <b-row>
      <b-col md="9">
        <p class="card-text">
          {{ $t("label_reports_genderGap_genderEqualityIndex_description") }}
        </p>
      </b-col>
      <b-col>
        <div
          v-if="generalIndex"
          id="generalIndex"
          class="general-index center-block"
          :class="
            generalIndex >= 50
              ? generalIndex > 75
                ? 'positive'
                : 'intermediate'
              : 'negative'
          "
        >
          {{ generalIndex | currency("", 0, { thousandsSeparator: "" }) }}%
        </div>
        <div v-if="!generalIndex" class="general-index center-block negative">
          0%
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CardGeneralIndex",
  props: {
    height: {
      type: String,
      default: "auto",
    },
  },
  computed: mapGetters(["generalIndex"]),
};
</script>

<style lang="scss" scoped>
/* components/cards/CardGeneralIndex */
.general-index {
  font-size: 3rem;
  border-radius: 20px;
  text-align: center;
}
.col-8 {
  padding-right: 5px;
}
.col {
  padding-left: 5px;
}
.card-title {
  text-align: left;
}
</style>
